import React, { createRef, useContext, useMemo } from 'react';

import { Dialog } from 'primereact/dialog';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

import { UserDetailsContext } from 'context/userDetailsContext';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

import { bytesToFormattedSize } from 'utils/utils';
import CustomHeader from './CustomHeader';
import FileVersionTitleTemplate from './FileVersionTitleTemplate';
import UploadedTemplate from '../../view/list/templates/UploadedTemplate';
import FileVersionActionsTemplate from './FileVersionActionsTemplate';

function FileVersionsModal() {
  const userContext = useContext(UserDetailsContext);
  const { modals, selectedItem } = useFileManagerContext();
  const { showUploadedVersionsModal, setShowUploadedVersionsModal } = modals;

  const versions = selectedItem?.versions ?? [];
  const itemsRef = useMemo(
    () =>
      Array(versions.length)
        .fill(null)
        .map(() => createRef()),
    [versions.length]
  );

  return (
    <Dialog
      header={<CustomHeader title="File Versions" onHide={() => setShowUploadedVersionsModal(false)} />}
      visible={showUploadedVersionsModal}
      style={{ width: '50%' }}
      onHide={() => setShowUploadedVersionsModal(false)}
      className="rounded casefile-wrap datatable-responsive"
      closable={false}
      draggable={false}
    >
      <DataTable
        value={versions}
        responsiveLayout="scroll"
        className="p-datatable-responsive"
        sortField="version_uploaded" //default sort field for table
        sortOrder={-1} // -1 for descending and 1 for ascending order
      >
        <Column
          className="col-lg-45"
          field="display_name"
          header="Title"
          body={(rowData) => <FileVersionTitleTemplate rowData={rowData} />}
          sortable
        />
        <Column
          field="size"
          header="File Size"
          body={(rowData) => <span className="text-muted">{rowData?.size ? bytesToFormattedSize(rowData.size) : '-'}</span>}
          sortable
          style={{ width: '100px' }}
        />
        <Column
          field="version_edited"
          header="Date Uploaded"
          body={(rowData) => <UploadedTemplate userContext={userContext} rowData={rowData} />}
          sortable
        />
        <Column
          body={(rowData, e) => <FileVersionActionsTemplate rowData={rowData} e={e} itemsRef={itemsRef} />}
          header="Actions"
          exportable={false}
        />
      </DataTable>
    </Dialog>
  );
}

export default FileVersionsModal;
